const isNavigatorAvailable = () => typeof navigator !== 'undefined'

export default isNavigatorAvailable
